<template>
  <div>
    <div class="con" v-loading="loading">
      <div class="box-card" v-if="portData">
        <div>
          <p style="font-size: 16px; margin-bottom: 10px;margin-top: 20px">{{$t('lang.port.portForwards')}}</p>
          <el-table :data="portData" border strip>
            <el-table-column :label="`${$t('lang.ConfigSetting.Name')}`">
              <template slot-scope="scope">
                <span>{{scope.row.options.name}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.ConfigSetting.Protocol')}`">
              <template slot-scope="scope">
                <span>{{scope.row.options.proto}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.ConfigSetting.Externalzone')}`">
              <template slot-scope="scope">
                <span>{{scope.row.options.src}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.port.outerPort')}`">
              <template slot-scope="scope">
                <span>{{scope.row.options.src_dport}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.ConfigSetting.Internalzone')}`">
              <template slot-scope="scope">
                <span>{{scope.row.options.dest}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.ConfigSetting.InternalIPaddress')}`" min-width="120px">
              <template slot-scope="scope">
                <span>{{scope.row.options.dest_ip}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.port.innerPort')}`">
              <template slot-scope="scope">
                <span>{{scope.row.options.dest_port}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.port.enable')}`">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.options.enabled"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('lang.ConfigSetting.operating')}`" min-width="150px">
              <template slot-scope="scope">
                <el-button @click="editRedirect(scope.row)" type="primary" size="small">{{$t('lang.Button.edit')}}</el-button>
                <el-button type="danger" size="small" @click="deleteRedirect(scope.row, scope.$index)">{{$t('lang.Button.delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <add-table :deviceDid="deviceDid" :IpList="IpList" :deviceSn="deviceSn" @addRedirect="addRedirect"></add-table>
          <edit-dialog ref="editDialog" :deviceDid="deviceDid" :IpList="IpList" :deviceSn="deviceSn" @updateData='updateData'></edit-dialog>
          <el-button type="danger" size="mini" class="Config-Buttom" @click="updateRedirect">{{$t('lang.ConfigSetting.SaveApply')}}</el-button>
        </div>
      </div>
    </div>
   
  </div>
</template>
<script>
import SelectInput from '../SelectInput/index'
import AddInput from '../AddInput/index'
import { updateConfig,listConfig, getNetworkInfo } from '@/api/configurationlist'
import addTable from './components/addTable'
import editDialog from './components/editDialog'
import { cloneDeep, isEqual} from 'lodash'
// import networkInfo from '../networkInfo/index'

export default {
   props:["deviceDid", "deviceSn"],
  data(){
    return{
      protocolList:[
        {value:'tcp udp',label:'ALL'},
        {value:'tcp',label:'TCP'},
        {value:'udp',label:'UDP'},
        {value:'other',label: this.$t('lang.port.other')}
      ],
      wanList:[
        {value:'wan',label:'wan'}
      ],
      lanList:[
        {value:'lan',label:'lan'}
      ],
      centerDialogVisible:false,
      //弹出框数据
      DialogFromData:{},
      index:null,
      enabled:false,
      IpList:[],
      deleteOptions: [],
      // 记录长度
      rLength: 0,
      // 网络接口基本信息
      networkInfo: {},
      portData: [],
      loading: false,
      copyData: []
    }
  },
  components:{
    SelectInput,
    AddInput,
    addTable,
    editDialog,
    // networkInfo
  },
  mounted(){
    //获取下拉ip列表
    listConfig(this.deviceSn,this.deviceDid,[{section:'arp',config:'arp'}])
    .then((res)=>{
      this.IpList=res.data.data.mess[0].s_objects.map((val)=>{
        return {value:val.ipaddr,label:`${val.ipaddr} (${val.macaddr})`}
      })
      this.IpList.push({value:'自定义',label:this.$t('lang.ConfigSetting.custom')})
      this.IpList.push({value:'',label:this.$t('lang.firewall.all')})       
    })
    this.getConfig()
  },
  methods:{
    // 获取配置信息
    getConfig() {
      this.loading = true
      this.portData = []
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "redirect",
          config: "firewall",
          options: [
            { option: "target" },
            { option: "dest" },
            { option: "proto" },
            { option: "src_dport" },
            { option: "extzone" },
            { option: "dest_ip" },
            { option: "dest_port" },
            { option: "name" },
            { option: "enabled" },
            { option: "src_ip" },
            { option: "src_port" },
            { option: "src_dip" },
            { option: "src_dport" },
            { option: "reflection" },
            { option: "extra" },
            { option: "extport" },
            { option: "intport" },
            { option: "src" }
          ]
        }
      ]).then(res => {
        this.rLength = res.data.data.mess[0].s_objects.length
        res.data.data.mess[0].s_objects.forEach((item, index) => {
            let itemObj = item
            this.$set(itemObj, 'index', index)
          if(item.options.target != 'SNAT' && !['dmz_tcp_ports1','dmz_tcp_ports2','dmz_tcp_ports3'].includes(item.options.name)) {
            itemObj.options.enabled = itemObj.options.enabled == '0' ? false : true
            this.portData.push(itemObj)
          }
        })
        this.copyData = cloneDeep(this.portData)
        this.loading = false
      }).catch(err => {
        this.$message({
          message: this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    //新建端口转发
    newdata(index){
      this.portData.push({action:1,options:{
      src_dip: "",
      reflection: "",
      dest: "lan",
      src:'wan',
      enabled: "",
      target: "DNAT",
      src_ip: "",
      src_port: "",
      src_dport: "",
      proto: "tcp udp",
      dest_ip: "",
      extra: "",
      name: "Forward",
      dest_port: "",
      extzone:''
      }})
    },
    //启用禁用
    OnOff(){
      this.DialogFromData.enabled=this.DialogFromData.enabled==''?true:false
    },
    // 更新并应用
    updateRedirect() {
      if(!isEqual(this.copyData, this.portData)) {
        let data = []
        this.portData.forEach((item,index) => {
          if(item.action==undefined){
            this.portData[index].action = 0
          }
          let options = cloneDeep(item.options) 
          if(options.enabled) {
            options.enabled = '1'
          }else{
            options.enabled = '0'
          }
          data.push({
            section: "redirect",
            config: "firewall",
            action: item.action,
            index: [item.index],
            server: "firewall",
            options: options
          })
        })      
        this.deleteOptions.forEach((item, index) => {     
          let options = cloneDeep(item.options) 
          if(options.enabled) {
            options.enabled = '1'
          }else{
            options.enabled = '0'
          }
          data.push({
            section: "redirect",
            config: "firewall",
            action: item.action,
            index: [item.index],
            server: "firewall",
            options: options
          })
        })
        updateConfig(this.deviceSn,this.deviceDid,data).then((res)=>{
          if(res.data.data.mess===0){
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });
            this.deleteOptions = []
            this.getConfig()
          }else {
            this.$message({
            showClose: true,
            message: this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
            return
          }
        })
      }else{
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return
      }
    },
    // 更新数据
    updateData(){
      this.getConfig()
    },
    // 删除数据
    deleteRedirect(row, index) {
      if(row.action == undefined){// 不是后来添加的数据,若是原来的数据则保存到待删除数组中
         this.deleteOptions.push({
           index: row.index,
           options: row.options,
           sname: row.sname,
           action: 2
         })
         // 在列表中删除
         this.portData.splice(index, 1)
      }else{// 不然直接在列表中删除即可
        this.portData.splice(index, 1)
      }
    },
    // 添加端口转发
    addRedirect(value){
      let redirectObj = value
      redirectObj.index = this.rLength
      this.rLength = this.rLength + 1
      this.portData.push(redirectObj)
    },
    // 编辑端口转发
    editRedirect(row) {
      this.$refs.editDialog.show(row.options, row.index)
    },
  }
}
</script>
<style scoped>
.title{
  margin: 30px;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
}
.Add-Buttom{
  margin-top: 1rem;
  margin-left: 10%;
  margin-bottom: 1rem;
}
</style>
<style src='../common.css' scoped></style>

